import AbstractListView from '@UI/Store/AbstractListView';
import type RoleView from '@UI/Store/Roles/Views/RoleView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * No `addRole` / `updateRole` / `removeRole`: every role write refetches the list, so a local
 * insertion would only make `totalRecords` and the current page lie.
 */
class RolesListView extends AbstractListView<RoleView> {
	readonly accountId: number;
	readonly totalRecords: number;

	constructor(list: readonly RoleView[], accountId: number, totalRecords: number) {
		super(list, 'RolesListView');

		this.accountId = accountId;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}
}

export default RolesListView;
